// Copyright (c) 2016 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import {getFacetsPrimaryProductStatuses, getFacetsSecondaryProductStatuses} from '../../shared/repositories';
import actions from '../../actions-list';

export const getProductSearchStatus = () =>
    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        const allPromises = Promise.all.bind(Promise);

        try {

            const [primaryStatus, secondaryStatus] = await allPromises([
                getFacetsPrimaryProductStatuses(),
                getFacetsSecondaryProductStatuses()
            ]);

            const statusList = primaryStatus.concat(secondaryStatus);

            dispatch({
                statusList,
                type: actions.SET_PRODUCT_SEARCH_STATUS_FACET
            });

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/product/search/action-creators/get-product-status.js